import { services } from '@ambita/ambita-components-core';

export interface RawQueryParams {
  [index: string]: string;
  product?: string;
  orderid?: string;
  token?: string;
  nomap?: string;
  makeCSV?: string;
}

export interface QueryParams {
  product?: string;
  orderId?: string;
  token?: string;
  noMap?: boolean;
  makeCSV?: boolean;
}

const TOKEN_PREFIX = 'Bearer ';
const TOKEN_REGEXP = /[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/;

const stripToken = (token: string): string => {
  return token.replace(TOKEN_PREFIX, '');
};

export const getRawQueryParams = (): RawQueryParams => {
  return services.util.decodeUriQuery(location.search.substr(1)) as RawQueryParams;
};

export const getAccessTokenWithBearer = (): string => {
  const rawToken = sessionStorage.getItem('access_token');

  if (!rawToken) {
    throw new Error('Not authenticated');
  } else if (rawToken && rawToken.indexOf(TOKEN_PREFIX) < 0) {
    return `${TOKEN_PREFIX}${rawToken}`;
  } else {
    return rawToken;
  }
};

export const removeTokenFromURL = (): void => {
  const url = new URL(window.location.href);
  const params = new URLSearchParams(url.search);
  const tokenWithBearer = params.get('token');

  if (tokenWithBearer) {
    const token = stripToken(tokenWithBearer);
    sessionStorage.setItem('access_token', token);
    params.delete('token');
  }

  window.history.replaceState({}, '', `${location.pathname}?${params}`);
};

export const getQueryParams = (): QueryParams => {
  const query = getRawQueryParams();
  const parsedQuery: QueryParams = {};

  if (query.product) {
    parsedQuery.product = query.product;
  }

  if (query.orderid) {
    parsedQuery.orderId = query.orderid;
  }

  if (query.token && TOKEN_REGEXP.test(query.token)) {
    parsedQuery.token = stripToken(query.token);
  }

  if (query.nomap === 'true' || query.nomap === '1') {
    parsedQuery.noMap = true;
  }

  if (query.makeCSV === 'true' || query.makeCSV === '1') {
    parsedQuery.makeCSV = true;
  }

  return parsedQuery;
};
